export const FLOATING_MESSAGE_IMAGES = {
  WARNING: 'warning.svg',
  SUCCESS_BLUE: 'success-blue.svg'
};
